import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Grid } from '@material-ui/core';
import { CloudUpload, Grade } from '@material-ui/icons';
import { getMarketName } from '../features/app/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { notify } from 'features/notificationSystem/actions';
import { FormattedMessage } from 'react-intl';
import axios from 'axios';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(4),
    height: 'calc(100% - 64px)'
  },
  header: {
    backgroundColor: '#fafafa',
    height: 64,
    paddingTop: 16,
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  },
  headerText: {
    paddingLeft: 16,
    fontSize: '1.25rem',
    fontFamily: 'Roboto',
    fontWeight: 500,
    lineHeight: '1.6'
  },
  paper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 15,
    backgroundColor: '#fff',
    paddingBottom: 15,
    borderRadius: 4,
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
  }
}));

const UploadFileView = () => {
  const classes = useStyles();
  const currOrganization = useSelector(getMarketName);
  const dispatch = useDispatch();

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const accessToken = localStorage.getItem('token');
  const handleFileChange = e => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    if (selectedFile) {
      setFileName(selectedFile.name);
    } else {
      setFileName('');
    }
  };

  const handleUpload = async () => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(
        `${process.env.REACT_APP_DATA_API_URL}/kc/uploader/${currOrganization}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${accessToken}`
          }
        }
      );

      // Handle response
      console.log('File uploaded successfully:', response.data);
      dispatch(
        notify({
          message: [
            <FormattedMessage id="notify.uploadSuccess" key="success" />
          ],
          variant: 'success'
        })
      );
    } catch (error) {
      console.error('Error uploading file:', error.response.data.message);
      dispatch(
        notify({
          message: error.response.data.message,
          variant: 'error'
        })
      );
    }
  };
  return (
    <div className={classes.container}>
      <div>
        <div className={classes.header}>
          <span className={classes.headerText}>Upload Excel</span>
        </div>
        <div className={classes.paper}>
          <Grid container>
            <Grid item sm={6} style={{ textAlign: 'right' }}>
              <input
                accept=".xls,.xlsx"
                id="excel-file"
                type="file"
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />

              <label htmlFor="excel-file" style={{ marginRight: '10px' }}>
                <Button
                  variant="contained"
                  component="span"
                  color="primary"
                  sx={{ mr: 2 }}
                >
                  Select Excel File
                </Button>
              </label>
              <div
                style={{
                  paddingRight: '10px',
                  marginTop: '5px',
                  color: 'blue'
                }}
              >
                {fileName}
              </div>
            </Grid>
            <Grid item sm={6}>
              <Button
                variant="contained"
                onClick={handleUpload}
                disabled={!file}
                color="primary"
                sx={{ ml: 2 }}
              >
                Upload
                <svg
                  style={{ marginLeft: '10px' }}
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
                    fill={file ? '#ffffff' : '#808080'}
                  />
                </svg>
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default UploadFileView;
